export enum ClassProgress {
  COMPLETED = "COMPLETED",
  INCOMPLETE = "INCOMPLETE",
}
